import { useState } from "react";
import { Download, Package, Loader2, Check, Smartphone, Monitor, Server } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function DownloadPage() {
  const [downloading, setDownloading] = useState(false);
  const [done, setDone] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const resp = await fetch(`${BACKEND_URL}/api/download/project`);
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "betmodel_v8.2.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setDone(true);
    } catch (e) {
      console.error(e);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-white font-body flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-6 animate-slide-up">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="w-16 h-16 bg-volt rounded-md flex items-center justify-center mx-auto">
            <Package className="w-8 h-8 text-obsidian" />
          </div>
          <h1 className="font-heading text-3xl font-black uppercase tracking-tight">BetModel v8.2</h1>
          <p className="text-txt-secondary text-sm">Download completo do projeto</p>
        </div>

        {/* Contents */}
        <div className="bg-surface border border-line rounded-sm p-5 space-y-3">
          <h3 className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-txt-secondary">
            Conteudo do ZIP
          </h3>
          <div className="space-y-2">
            <div className="flex items-center gap-3">
              <Server className="w-4 h-4 text-volt" />
              <div>
                <p className="text-sm font-semibold">backend/</p>
                <p className="text-[10px] text-txt-secondary">FastAPI + modelo XgModelV8 + auth JWT</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Smartphone className="w-4 h-4 text-azure" />
              <div>
                <p className="text-sm font-semibold">react-native-app/</p>
                <p className="text-[10px] text-txt-secondary">App Android com AdMob + EAS Build config</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Monitor className="w-4 h-4 text-warning" />
              <div>
                <p className="text-sm font-semibold">web-frontend/</p>
                <p className="text-[10px] text-txt-secondary">React + Tailwind (versao web)</p>
              </div>
            </div>
          </div>
        </div>

        {/* Download Button */}
        <button
          data-testid="download-zip-btn"
          onClick={handleDownload}
          disabled={downloading}
          className={`w-full font-bold uppercase tracking-wide px-6 py-4 rounded-sm transition-all flex items-center justify-center gap-2 text-lg ${
            done
              ? "bg-volt/20 border border-volt text-volt"
              : "bg-volt text-volt-fg hover:bg-volt-hover active:scale-[0.98]"
          }`}
        >
          {downloading ? (
            <><Loader2 className="w-5 h-5 animate-spin" /> A preparar ZIP...</>
          ) : done ? (
            <><Check className="w-5 h-5" /> Download concluido!</>
          ) : (
            <><Download className="w-5 h-5" /> Descarregar Projeto (ZIP)</>
          )}
        </button>

        {done && (
          <div className="bg-surface border border-line rounded-sm p-4 space-y-2 text-xs text-txt-secondary">
            <p className="font-bold text-white">Proximo passo:</p>
            <p>1. Extrai o ZIP no teu PC</p>
            <p>2. <code className="font-mono bg-obsidian px-1 rounded">cd react-native-app && npm install</code></p>
            <p>3. <code className="font-mono bg-obsidian px-1 rounded">npx eas login</code></p>
            <p>4. <code className="font-mono bg-obsidian px-1 rounded">npx eas build --platform android --profile preview</code></p>
          </div>
        )}
      </div>
    </div>
  );
}
